export default __webpack_public_path__ + "4be3742acf1398a163270ad40113d746.png";